import { render, staticRenderFns } from "./MaterialUploadAudio.vue?vue&type=template&id=9a60406a&scoped=true&"
import script from "./MaterialUploadAudio.vue?vue&type=script&lang=js&"
export * from "./MaterialUploadAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60406a",
  null
  
)

export default component.exports